import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import Landing from "@/pages/Landing";
import MyPlanCost from "@/pages/MyPlanCost";
import SpaceCost from "@/pages/SpaceCost";
import SpaceCostPricing from "@/pages/SpaceCostPricing";
import SpaceCostHowItWorks from "@/pages/SpaceCostHowItWorks";
import SpaceCostFaq from "@/pages/SpaceCostFaq";
import ProjectList from "@/pages/ProjectList";
import ProjectDashboard from "@/pages/ProjectDashboard";
import HowItWorks from "@/pages/HowItWorks";
import Faq from "@/pages/Faq";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Admin from "@/pages/Admin";
import AnalyticsReport from "@/pages/AnalyticsReport";
import Disclaimer from "@/pages/Disclaimer";
import InvitePage from "@/pages/InvitePage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import Pricing from "@/pages/Pricing";
import BillingCallback from "@/pages/BillingCallback";
import { AuthProvider } from "@/lib/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import HelpPill from "@/components/HelpPill";
import ScrollToTop from "@/components/ScrollToTop";
import usePageViewTracker from "@/lib/usePageViewTracker";

// Lives inside <BrowserRouter> so the page-view hook can read useLocation().
function AnalyticsTracker() {
  usePageViewTracker();
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-[#FAFAF9] text-[#1C1C1C]">
      <TooltipProvider delayDuration={150}>
        <BrowserRouter>
          <ScrollToTop />
          <AnalyticsTracker />
          <AuthProvider>
            <ImpersonationBanner />
            <Routes>
              <Route path="/" element={<MyPlanCost />} />
              <Route path="/flipcost" element={<Landing />} />
              <Route path="/spacecost" element={<SpaceCost />} />
              <Route path="/spacecost/pricing" element={<SpaceCostPricing />} />
              <Route path="/spacecost/how-it-works" element={<SpaceCostHowItWorks />} />
              <Route path="/spacecost/faq" element={<SpaceCostFaq />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route
                path="/projects"
                element={
                  <ProtectedRoute>
                    <ProjectList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/projects/:id"
                element={
                  <ProtectedRoute>
                    <ProjectDashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="/how-it-works" element={<HowItWorks />} />
              {/* Legacy redirect — Cost Library is now a tab inside each project */}
              <Route path="/library" element={<Navigate to="/projects" replace />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/invite/:token" element={<InvitePage />} />
              <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/billing/callback" element={<BillingCallback />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/analytics/report"
                element={
                  <ProtectedRoute adminOnly>
                    <AnalyticsReport />
                  </ProtectedRoute>
                }
              />
            </Routes>
            <HelpPill />
          </AuthProvider>
        </BrowserRouter>
        <Toaster theme="light" />
      </TooltipProvider>
    </div>
  );
}

export default App;
